import jsSHA from 'jssha';
import randomWords from 'random-words';

export class IdentifyFactory {
  private constructor() {
    //
  }

  static get instance(): IdentifyFactory {
    return new IdentifyFactory();
  }
  /**
   * UUIDを生成する
   * @param {*} paStrong
   */
  getUniqueStr(strong = 1000): string {
    return new Date().getTime().toString(16) + Math.floor(strong * Math.random()).toString(16);
  }

  randomWordsForId(): string {
    return randomWords({
      exactly: 1,
      wordsPerString: 2,
      seperator: '-',
      maxLength: 4,
    })[0];
  }

  /**
   *
   */
  randomColour(): string {
    const num = Math.floor(Math.random() * Math.pow(2, 24));
    return '#' + ('00000' + num.toString(16)).substr(-6);
  }

  getHashId(original: string): string {
    const HASH_KEY = 'HASH_KEY';
    const sha256 = new jsSHA('SHA-1', 'TEXT');
    sha256.update(original + HASH_KEY);
    return 'id' + sha256.getHash('HEX');
  }
}
